import {
    CREATE_PRIZE_SUCCESS,
    DELETE_PRIZE_SUCCESS,
    UPDATE_PRIZE_SUCCESS,
    GET_PRIZES_SUCCESS
} from './constants';

const initialNavigationState = {};
/**
 *
 * @param state
 * @param action
 * @returns {*[]}
 */
const prizesReducer = ( state = initialNavigationState, action ) => {
    switch ( action.type ) {
        case GET_PRIZES_SUCCESS: {
            return { ...action.prizes };
        }

        case CREATE_PRIZE_SUCCESS: {
            const oldPrizes = Object.keys( state ).map( i => state[ i ] );
            const newPrizesList = [ ...oldPrizes, action.prize ];
            return { ...newPrizesList };
        }
        case DELETE_PRIZE_SUCCESS: {
            return { ...action.prizes };
        }

        case UPDATE_PRIZE_SUCCESS: {
            return { ...action.prizes };
        }

        default:
            return state;
    }
};

export { prizesReducer as prizes };